import ErrorPage from '../../lib/ErrorPage/ErrorPage';

export const HasAccess = ({ accessFn, children }) => (accessFn() ? children : <ErrorPage errorInfo={{ code: 403 }} />);
